import axios from 'axios';
import {
	AuthActiveUserDTO,
	AuthChangePasswordInputDTO,
	AuthChangePasswordOutputDTO,
	AuthForgotPasswordInputDTO,
	AuthLoginInputDTO,
	AuthLoginOutDTO,
	AuthRegisterInputDTO,
	AuthRegisterOutDTO,
	AuthSetupPasswordInputDTO,
	AuthSetupPasswordOutDTO,
	AuthUpdateAccountDataInputDTO,
	AuthVerifyEmailInputDTO,
	AuthVerifyEmailOutDTO
} from "@haohan/papi-dto";

export const authApi = {
	async loadActiveUser(): Promise<AuthActiveUserDTO> {
		const res = await axios.get<AuthActiveUserDTO>('/api/auth/session/');
		return res.data;
	},
	async login(input: AuthLoginInputDTO): Promise<AuthLoginOutDTO> {
		const res = await axios.post<AuthLoginOutDTO>(
			'/api/auth/login/', input
		);
		return res.data;
	},
	async logout() {
		const res = await axios.post<AuthLoginOutDTO>(
			'/api/auth/logout/'
		);
		return res.data;
	},
	async register(input: AuthRegisterInputDTO): Promise<AuthRegisterOutDTO> {
		const res = await axios.post<AuthRegisterOutDTO>(
			'/api/auth/register/', input
		);
		return res.data;
	},
	async forgotPassword(input: AuthForgotPasswordInputDTO) {
		const res = await axios.post<AuthRegisterOutDTO>(
			'/api/auth/password/forgot/', input
		);
		return res.data;
	},
	async setupPassword(input: AuthSetupPasswordInputDTO) {
		const res = await axios.post<AuthSetupPasswordOutDTO>(
			'/api/auth/password/setup/', input
		);
		return res.data;
	},
	async changePassword(input: AuthChangePasswordInputDTO) {
		const res = await axios.post<AuthChangePasswordOutputDTO>(
			'/api/auth/password/change/', input
		);
		return res.data;
	},
	async verifyEmail() {
		const res = await axios.post('/api/auth/email/verify/request');
		return res.data;
	},
	async finishVerifyEmail(input: AuthVerifyEmailInputDTO) {
		const res = await axios.post<AuthVerifyEmailOutDTO>(
			'/api/auth/email/verify', input
		);
		return res.data;
	},
	async updateAccountData(input: AuthUpdateAccountDataInputDTO) {
		const res = await axios.post<AuthActiveUserDTO>(
			'/api/auth/update/info', input
		);
		return res.data;
	},
};
